export const modalDelete = {
	messageProfile:
		"Ao confirmar a ação você exclui permanentemente o perfil fiscal {{ profile }}. Deseja continuar?",
	messageGroup:
		"Ao confirmar a ação você exclui permanentemente o grupo fiscal {{ group }}. Deseja continuar?",
	profileDeletedSuccess: "Perfil fiscal excluído com sucesso!",
	groupDeletedSuccess: "Grupo fiscal excluído com sucesso!",
};
